import styled, { css } from 'styled-components';

export const Content = styled.div`
  margin-right: 5px;
  line-height: 1;
  height: 22px;
  width: 22px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  /* thin dual ring so the chip reads on any background, light or dark zone color */
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.16), inset 0 0 0 2px rgba(0, 0, 0, 0.12);
  b {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.3px;
    color: ${(props) => props.$text};
    text-shadow: ${(props) => (props.$text === '#ffffff' ? '0 1px 1px rgba(0, 0, 0, 0.28)' : 'none')};
  }
  ${(props) =>
    props.$big &&
    css`
      height: 43px;
      width: 43px;
      border-radius: 11px;
      b {
        font-size: 18px;
        letter-spacing: 0.5px;
      }
    `}
`;
